<template>
    <Card>
        <template v-slot:icon>
            <i v-if="icon" :class="[icon]" class="mr-1"/>
        </template>
        <template v-slot:title>
            {{ title }}
        </template>
        <template v-slot:description>
            {{ description }}
        </template>
        <template v-slot:toolbar>
            <slot name="actions"/>
        </template>
        <slot name="body"/>
        <template v-slot:footer>
            <slot name="footer"/>
        </template>
    </Card>
</template>
<script>
import Card from '@components/Cards/Card.vue';

export default {
    components: {Card},

    props: {
        title: {
            type: String,
            default() {
                return __('general.settings');
            }
        },
        icon: {
            type: String,
            default: 'fas fa-cogs'
        },
        description: {
            type: String,
            default() {
                return __('actions.manage_thing', {thing: __('general.settings')});
            }
        },
    },
};
</script>
